export const ERROR_TYPES = {
    CLIENT_IS_BLOCKED: '10001',
    CLIENT_ACCOUNT_NOT_IN_HOLDING: '6002',
    POSTALCODE_NOT_MATCH_PROVINCE: '0243',
    POSTALCODE_NOT_VALID: '0242',
};

export const FORM_VALIDATIONS = {
    FIELDS: {
        PRIMARY: ['gender', 'nationality', 'birthCountry', 'birthPopulation', 'cellPhone', 'cellPhoneConfirmation'],
        FIRST_ADDRESS: ['nameOfRoad', 'addressNumber', 'postalCode', 'town'],
        SECOND_ADDRESS: ['nameOfRoad2', 'addressNumber2', 'postalCode2'],
    },
    EXTRA_FIELDS: {
        PRIMARY: ['gender', 'nationality', 'cellPhone', 'birthCountry', 'birthPopulation', 'cellPhoneConfirmation'],
        FIRST_ADDRESS: ['nameOfRoad', 'addressNumber', 'postalCode', 'typeOfRoad', 'town', 'province'],
        SECOND_ADDRESS: ['nameOfRoad2', 'addressNumber2', 'postalCode2', 'typeOfRoad2', 'province2'],
    },
};
